import { afterNextRender,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mp-select-dropdown',
  imports: [
    CommonModule
  ],
  templateUrl: './mp-select-dropdown.component.html',
  styleUrls: ['./mp-select-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MpSelectDropDownComponent {

  @ViewChild('dropdown', { read: ElementRef }) dropdownElementRef: ElementRef;

  constructor(private readonly ngZone: NgZone) {
    afterNextRender({
      write: () => {
        this.computePosition();
        this.dropdownDisplayed.emit();
      }
    });
  }

  @Input({ required: true }) anchor: ElementRef;

  @Output() public dropdownDisplayed = new EventEmitter<void>();

  private computePosition() {
    this.ngZone.runOutsideAngular(() => {
      const { bottom, height } = this.anchor.nativeElement.getBoundingClientRect();
      const maxHeight = window.innerHeight;
      const dropDownMeasure = this.dropdownElementRef?.nativeElement?.getBoundingClientRect();

      const translateX = -2;
      let translateY: number;

      if (bottom + dropDownMeasure.height > maxHeight - 10) {
        translateY = -dropDownMeasure.height - height + 3;
      } else {
        translateY = 1;
      }

      this.dropdownElementRef.nativeElement.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`;

      this.dropdownDisplayed.emit();
    });
  }
}
